import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/invyt-glass.css";
import App from "@/App";
import { installEventAuthInterceptor } from "@/utils/eventAuthInterceptor";
import { installVenuePersistence } from "@/utils/venuePersist";
import { installAuthCookieSync } from "@/utils/authCookieSync";
import { registerServiceWorker } from "@/serviceWorkerRegistration";
import { toast } from "sonner";

installAuthCookieSync(); // before venue persistence so its storage shim routes through the sync
installVenuePersistence();
installEventAuthInterceptor();
registerServiceWorker(() => {
  toast("A new version of Invyt is available", {
    id: "sw-update",
    description: "Refresh to get the latest.",
    duration: Infinity,
    action: { label: "Refresh", onClick: () => window.location.reload() },
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
